// @flow

import { USER_ROLE_TYPE_SYSTEM } from '@flow/libs/user';

// eslint-disable-next-line import/prefer-default-export
export const isRoleEditable = (role: Role) => Boolean(role) && role.type !== USER_ROLE_TYPE_SYSTEM;
